import { useContext } from 'react';

import { ExtensionDataContext } from '../../components/extension/ExtensionDataContext';

export const useTranslation = () => useContext(ExtensionDataContext).translate;
